import * as React from "react";
import { useBlobUrl } from "../../hooks/useBlobUrl";

type AuthedImageProps = Omit<React.ImgHTMLAttributes<HTMLImageElement>, "src"> & {
  /**
   * API-relativer Pfad zur geschützten Bildressource (z. B. `"/media/news/x.jpg"`
   * oder `cd.photo_url`). Absolute `http(s)`-URLs werden direkt gesetzt.
   */
  src: string | null | undefined;
  /** Optionaler Inhalt, solange das Bild lädt oder fehlschlägt. */
  fallback?: React.ReactNode;
};

/**
 * `<img>`-Ersatz, der die Bilddaten **authentifiziert** (Bearer via fetch-Wrapper)
 * als `blob:`-URL lädt — statt eines nackten `<img src="/api/media/...">`, das am
 * Session-Cookie/`access_token`-Query hinge. Vorbereitung auf den Bearer-only-Guard.
 *
 * Solange geladen wird oder ein Fehler auftritt, wird `fallback` gerendert (sonst
 * nichts). Liegt eine `blob:`-URL vor, wird ein normales `<img>` ausgegeben.
 */
export const AuthedImage: React.FC<AuthedImageProps> = ({ src, fallback = null, alt = "", ...imgProps }) => {
  const { url, loading, error } = useBlobUrl(src);

  if (loading || error || !url) {
    return <>{fallback}</>;
  }

  return <img src={url} alt={alt} {...imgProps} />;
};

export default AuthedImage;
